<div fxLayout="column">
  <h3>Zmiana stawki</h3>

  <div fxFlex="50">
    <mat-form-field fxFlex="100">
      <mat-label>Stawka % Partner</mat-label>
      <input matInput placeholder="Stawka % Partner" [formControl]="ratePaidControl" [required]="false">
    </mat-form-field>
  </div>
  <div fxLayout="row">
    <app-dict
      fxFlex="100" label="Ryzyko ASF"
      dictType="internal_risk" [required]="false"
      [formControl]="riskControl"
    ></app-dict>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
